

// Datei: src/shop_crit.public.getlink.js
// getlink.js - Navigation Service
const pageCache = {
    _data: new Map(),
    _maxSize: 50,
    _maxContentSize: 500000,
    _maxTotalSize: 5000000,
    _totalSize: 0,

    save(url, content, scrollY) {
        const contentSize = content.length * 2;
        if (contentSize > this._maxContentSize) return;

        const existing = this._data.get(url);
        if (existing) {
            this._totalSize -= existing.content.length * 2;
            this._data.delete(url);
        }

        while (
            (this._data.size >= this._maxSize || this._totalSize + contentSize > this._maxTotalSize)
            && this._data.size > 0
        ) {
            const firstKey = this._data.keys().next().value;
            this._totalSize -= this._data.get(firstKey).content.length * 2;
            this._data.delete(firstKey);
        }

        this._data.set(url, { content, scrollY, title: document.title });
        this._totalSize += contentSize;
    },

    get(url) {
        const data = this._data.get(url);
        if (data) {
            this._data.delete(url);
            this._data.set(url, data);
        }
        return data;
    }
};

let navigationSequence = 0;
const cssLoadPromises = new Map();
const ajaxPageCss = [
    // Seit dem Bundle-Schnitt vom 2026-09-16 liegt die Uebersichts-Familie
    // (content_home, content_usicht*) in style-usicht.min.css. Ohne diesen
    // Eintrag kaeme ein per AJAX nachgeladenes Listing ohne seine Kachel- und
    // Bannerregeln an.
    //
    // Die Reihenfolge ist hier kein Problem, und das ist der Grund, warum
    // dieser Weg nichts einfuegen muss: ensureStylesheet() nimmt ueber
    // findCssLink() den LINK, der schon im Kopf steht - auf einer schlanken
    // Seite ist das der rel='prefetch'-Link, und der steht bereits an seiner
    // richtigen Stelle vor style-responsive.min.css. Angelegt wird nur, wenn
    // gar keiner da ist.
    {
        name: 'usicht',
        file: 'style-usicht.min.css',
        selector: '.content_usicht, .content_home_usicht, #content_usicht_home, #content_usicht_grid, #content_home_banner, #content_home_info, #content_home_marke, #content_home_sale, .content_usicht_banner, .content_usicht_filter'
    },
    {
        name: 'artikel',
        file: 'style-artikel.min.css',
        selector: '#content_artikel, #content_artikel_basket_basket, #artikel_to_basket'
    },
    {
        name: 'kasse',
        file: 'style-kasse.min.css',
        selector: '#content_basket_head, #content_basket_basket, #content_kasse_bestellen, .content_kasse_container, .content_basket_box'
    }
];

function getAssetVersion() {
    const cssLink = document.querySelector('link[href*="/static/css/style.min.css?v="], link[href*="/static/css/style-responsive.min.css?v="]');
    const cssVersion = cssLink?.href?.match(/[?&]v=([^&]+)/)?.[1];
    if (cssVersion) return cssVersion;

    const versionCookie = document.cookie.match(/(?:^|;\s*)version=([^;]+)/)?.[1];
    if (versionCookie) return decodeURIComponent(versionCookie);

    const script = document.querySelector('script[src*="/static/js/dist/"][src*="?v="]');
    return script?.src?.match(/[?&]v=([^&]+)/)?.[1] || '';
}

function buildCssHref(file) {
    const version = getAssetVersion();
    return `${location.origin}/static/css/${file}${version ? `?v=${version}` : ''}`;
}

function cssLinkMatches(link, file) {
    const rawHref = link.href || link.dataset.href || link.getAttribute('href') || link.getAttribute('data-href') || '';
    if (!rawHref) return false;

    try {
        return new URL(rawHref, location.origin).pathname.endsWith(`/static/css/${file}`);
    } catch {
        return rawHref.includes(`/static/css/${file}`);
    }
}

function findCssLink(file) {
    return Array.from(document.querySelectorAll('link[href], link[data-href]'))
        .find(link => cssLinkMatches(link, file)) || null;
}

function hasActiveStylesheet(file) {
    return Array.from(document.styleSheets).some(sheet => {
        if (!sheet.href) return false;

        try {
            return new URL(sheet.href, location.origin).pathname.endsWith(`/static/css/${file}`);
        } catch {
            return sheet.href.includes(`/static/css/${file}`);
        }
    });
}

/**
 * Haengt ein Stylesheet an der Stelle ein, an der es der Vollseitenaufruf
 * ausgibt: VOR style-responsive.min.css.
 *
 * Warum nicht `document.head.appendChild`: style_responsive.css teilt 28
 * Tie-Paare mit abweichendem Wert mit der Uebersichts-Familie, 9 mit
 * content_artikel.css und 7 mit der Kasse-Familie - gleiche Spezifitaet,
 * gleiche Wichtigkeit, ueberlappender Media-Kontext. Eine Media Query erhoeht
 * die Spezifitaet nicht; wer dahinter einhaengt, dreht diese Ueberschreibungen
 * um (grid-template-columns, aspect-ratio, font-size, position, width,
 * min-height).
 *
 * Der Regelfall ist harmlos: ein bereits vorhandener `rel=prefetch`-Link steht
 * an der richtigen Stelle und wird nur hochgestuft. Dieser Weg hier greift,
 * wenn gar kein Link da ist - und das passiert wirklich:
 * shop_crit.public.ajax.js entfernt bei jeder Antwort mit `Link:`-Kopf ALLE
 * `link[rel=preload]`, und im Erstbesuch stehen die Bundles genau so da.
 *
 * Dieselbe Logik steht in artikel.js und in ajax_page_css_guard()
 * (index_slewo.php). Drei Bundles ohne gemeinsames Modul - wer eine aendert,
 * aendert alle drei.
 *
 * Die drei sind gleichwertig, aber nicht wortgleich: die beiden JS-Fassungen
 * ankern nur an style-responsive.min.css, ajax_page_css_guard() zusaetzlich am
 * ersten vorhandenen Nachfolger-Bundle (usicht, artikel, kasse). Das Ergebnis
 * ist dasselbe, solange eingefuegt wird, was die Liste vorgibt - der PHP-Weg
 * baut den Kopf aber selbst auf und kennt die Nachfolger deshalb schon.
 */
function einhaengen(link) {
    const alle = document.getElementsByTagName('link');
    for (let i = 0; i < alle.length; i++) {
        if ((alle[i].href || '').indexOf('/static/css/style-responsive.min.css') !== -1) {
            alle[i].parentNode.insertBefore(link, alle[i]);
            return;
        }
    }
    document.head.appendChild(link);
}

function ensureStylesheet(file, marker) {
    if (hasActiveStylesheet(file)) return Promise.resolve();
    if (cssLoadPromises.has(file)) return cssLoadPromises.get(file);

    const href = buildCssHref(file);
    const existing = findCssLink(file);
    const link = existing || document.createElement('link');

    const promise = new Promise(resolve => {
        let resolved = false;
        const finish = () => {
            if (resolved) return;
            resolved = true;
            cssLoadPromises.delete(file);
            resolve();
        };

        link.addEventListener('load', finish, { once: true });
        link.addEventListener('error', finish, { once: true });
        setTimeout(finish, 2500);

        link.type = 'text/css';
        link.media = link.media || 'all';
        link.as = 'style';
        link.dataset.ajaxCss = marker;
        link.classList.remove('css_load');

        if (!link.href && link.dataset.href) link.href = link.dataset.href;
        if (!link.href) link.href = href;
        link.rel = 'stylesheet';

        if (!link.parentNode) einhaengen(link);
        if (hasActiveStylesheet(file)) finish();
    });

    cssLoadPromises.set(file, promise);
    return promise;
}

function ensurePageCssForContent(container) {
    if (!container?.querySelector) return Promise.resolve();

    const requiredCss = ajaxPageCss
        .filter(asset => container.querySelector(asset.selector))
        .map(asset => ensureStylesheet(asset.file, asset.name));

    return requiredCss.length ? Promise.all(requiredCss) : Promise.resolve();
}

function executeScripts(container) {
    container.querySelectorAll("script").forEach(oldScript => {
        const newScript = document.createElement("script");
        if (oldScript.src) {
            newScript.src = oldScript.src;
            newScript.async = false;
        } else {
            newScript.textContent = oldScript.textContent;
        }
        oldScript.parentNode.replaceChild(newScript, oldScript);
    });
}

function prepareMenuContent(container) {
    const links = container.querySelectorAll(".content_menu_box a");

    links.forEach(link => {
        const next = link.nextElementSibling;

        if (link.getAttribute("target") !== "_blank" && next?.tagName === "UL") {
            if (!next.querySelector("li.back")) {
                const href = link.getAttribute("href");
                const t = link.innerHTML;
                const c = !next.querySelector(".select") ? "select" : "";
                next.insertAdjacentHTML("afterbegin",
                    `<li class='back'>${t}</li><li class='all ${c}'><a href='${href}'>alle in dieser Kategorie</a></li>`
                );
            }
            link.classList.add("init");
        }

        if (link.dataset.kategorie && !link.querySelector("span")) {
            link.insertAdjacentHTML("beforeend", "<span></span>");
        }
    });

    const menuBox = container.querySelector(".content_menu_box");
    const hasSelect = menuBox?.querySelector("ul>li.select");
    menuBox?.classList.toggle("select", !!hasSelect);
}

function prepareContent(htmlContent) {
    const template = document.createElement('template');
    template.innerHTML = htmlContent || '';
    prepareMenuContent(template.content);
    return template.content;
}

function restoreCachedLazyState(container) {
    if (!container?.querySelectorAll) return;

    container.querySelectorAll('.lazyload img, img.lazyload').forEach(image => {
        const lazyContainer = image.classList.contains('lazyload')
            ? image
            : image.closest('.lazyload') || image;

        image.classList.remove('preload');
        lazyContainer.classList.remove('preload', 'lazyview');

        if (!image.dataset.srcset && (image.getAttribute('srcset') || image.getAttribute('src'))) {
            image.classList.add('init', 'load');
            image.dataset.loaded = '1';
            lazyContainer.classList.add('init', 'observe', 'load', 'unload');
            return;
        }

        delete image.dataset.loaded;
        image.classList.remove('init', 'observe', 'load', 'unload');
        lazyContainer.classList.remove('init', 'observe', 'load', 'unload');
    });

    container.querySelectorAll('.lazyload').forEach(lazyElement => {
        if (lazyElement.matches('img') || lazyElement.querySelector('img')) return;
        lazyElement.classList.remove('init', 'observe', 'load', 'unload', 'preload', 'lazyview');
    });

    container.querySelectorAll('.image_init, .init').forEach(element => {
        if (element.matches('.lazyload, .lazyload *')) return;
        element.classList.remove('init', 'image_init');
    });
}

function removePageScopedElements() {
    document.getElementById("artikel_to_basket")?.remove();
    document.getElementById("filterbox")?.remove();
}

export function getlink(link) {
    const { html, domCache } = window;
    const navigationId = ++navigationSequence;

    html.classList.remove("basket_right_load");

    if (typeof window.livesearch_unload === 'function') {
        window.livesearch_unload();
    }

    if (!history.pushState) {
        location.href = link;
        return;
    }

    const sitecontent = document.getElementById("sitecontent");

    pageCache.save(location.href, sitecontent.innerHTML, html.scrollTop || scrollY || 0);

    history.replaceState({
        url: location.href,
        scrollY: html.scrollTop || scrollY || 0
    }, document.title, location.href);

    removePageScopedElements();

    window.check_content_usicht_filter = false;
    window.scroll_to_top = 0;

    return ajax({
        type: "GET",
        url: link,
        dataType: "json",
        progressBar: true
    }).then(async r => {
        if (navigationId !== navigationSequence) return r;

        window.zoom_history = true;

        if (typeof window.livesearch_unload === 'function') {
            window.livesearch_unload();
        }

        const nav = domCache.get("nav");
        nav.classList.add("hide");
        nav.classList.remove("select", "select2", "select3", "select4");
        domCache.getAll("nav .select").forEach(el => el.classList.remove("select"));
        document.getElementById("site").classList.remove("overlay");
        nav.dispatchEvent(new MouseEvent("mouseleave"));
        setTimeout(() => nav.classList.remove("hide"), 500);

        if (!window.check_content_usicht_filter ||
            (window.check_content_usicht_filter &&
             document.documentElement.scrollTop > document.getElementById("content_usicht").getBoundingClientRect().top + innerHeight / 5)) {

            if (!domCache.get(".mobile_size") && window.scroll_to_top !== 1) {
                const header = domCache.get("header");
                window.scrollto(
                    header.offsetHeight +
                    domCache.get("#site>div:first-child").offsetHeight - 3 -
                    domCache.get("header div>nav").offsetHeight -
                    parseInt(getComputedStyle(document.body).marginTop) || 0
                );
            } else {
                window.scrollto(0);
            }
        }

        const virtualContent = prepareContent(r.content);
        await ensurePageCssForContent(virtualContent);
        if (navigationId !== navigationSequence) return r;

        sitecontent.textContent = '';
        sitecontent.appendChild(virtualContent);
        domCache.invalidate();

        const { meta } = r;
        if (meta) {
            if (meta.title) document.title = meta.title;
            if (meta.description) domCache.get("meta[name=description]").content = meta.description;
            if (meta.keywords) domCache.get("meta[name=keywords]").content = meta.keywords;
        }

        executeScripts(sitecontent);
        pageCache.save(link, sitecontent.innerHTML, 0);

        history.pushState({ url: link, scrollY: 0 }, document.title, link);

        // Beacon PV-Event fuer AJAX-Navigation (GA4-Paritaet)
        if (typeof window.__slBeaconPV === 'function') window.__slBeaconPV();

        if (typeof window.init === 'function') {
            window.init(r);
        }

        if (window.mobile_menu_load === 1 || (html.classList.contains("mm_load") && window.mobile_menu_load !== 2)) {
            if (typeof window.mobil_menu_unload === 'function') {
                window.mobil_menu_unload();
            }
        }
        window.mobile_menu_load = 0;

        return r;
    }).catch(error => {
        console.error(error);
        throw error;
    });
}

export async function updateContent(state) {
    if (!state?.url) return;
    const navigationId = ++navigationSequence;
    window.html?.classList.remove("basket_right_load");
    removePageScopedElements();

    const cached = pageCache.get(state.url);

    if (!cached?.content) {
        getlink(state.url);
        return;
    }

    const site = document.getElementById("site");

    if (site?.nextElementSibling) {
        Array.from(site.nextElementSibling.children).forEach(el => {
            if (!el.classList.contains("basket_right")) el.remove();
        });
    }

    const virtualContent = prepareContent(cached.content);
    await ensurePageCssForContent(virtualContent);
    if (navigationId !== navigationSequence) return;

    restoreCachedLazyState(virtualContent);

    const sitecontent = document.getElementById("sitecontent");
    sitecontent.innerHTML = '';
    sitecontent.appendChild(virtualContent);
    window.domCache?.invalidate?.();

    document.getElementById('content_artikel_image_zoom')?.remove();

    requestAnimationFrame(() => {
        const y = cached.scrollY ?? state.scrollY ?? 0;
        window.html.scrollTop = y;
        window.scrollTo(0, y);
    });

    if (cached.title) document.title = cached.title;

    executeScripts(sitecontent);

    if (typeof window.init === 'function') {
        window.init();
    }
}

// scrollto Helper - global verfügbar machen
window.scrollto = (target) => {
    let targetPosition;

    if (typeof target === 'string') {
        const element = window.domCache?.get(target);
        if (!element) return;
        targetPosition = element.getBoundingClientRect().top + window.scrollY;
    } else if (Number.isFinite(target)) {
        targetPosition = target;
    } else {
        return;
    }

    window.scrollTo({
        top: targetPosition,
        behavior: Math.abs(targetPosition - window.scrollY) > window.innerHeight * 2 ? 'auto' : 'smooth'
    });
};
